import { captureException } from '@sentry/react';
import AbstractTab from './AbstractTab';

export default class AbstractInfoTab extends AbstractTab {
    input;
    currentElement;
    speciesCount = 0;
    name = 'info';
    tooltip = 'Info (I)';
    icon = '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#information-line"></use></svg>';

    constructor(provider, tabContainer) {
        super(provider);

        this.container = this.p.createDiv().parent(tabContainer)
            .class("planner-aside-wrapper");
        this.positionInfoTab();
        this.placeholder = this.p.createElement('p', 'Select an element to show info')
            .parent(this.container)
            .class('mar-t-0');

        this.createInput();

        this.container.hide();
    }

    createInput() {
        throw new Error('createInput() not implemented');
    }

    positionInfoTab() {
        // this.container.position(this.sideBar.x, 0);
    }

    resizeWindow() {
        this.positionInfoTab();
    }

    update() { }

    activate() {
        this.container.show();
        if (this.currentElement) {
            this.input.show();
        }
    }

    deactivate() {
        this.container.hide();
    }
}
